/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import { primePaymentflowStartEmitter } from 'components/EventEmitters';
import { getVideoImg } from './utils';
import { getPrimeBlockerConfig, getCtaFormType } from '../../utils/primeUtil';
import s from './VideoBlocker.scss';

//function VideoBlocker(props) {
class VideoBlocker extends React.Component {
  static propTypes = {
    msid: PropTypes.string,
    imgsize: PropTypes.string,
    primeEndDate: PropTypes.string,
    hideBlockerAndResume: PropTypes.func,
    prc: PropTypes.string.isRequired,
    isVideoTheatreMinified: PropTypes.bool,
  };

  static defaultProps = {
    primeEndDate: null,
    msid: '',
    imgsize: '',
    hideBlockerAndResume() {},
    isVideoTheatreMinified: false,
  };

  constructor(props) {
    super(props);
    this.blockerRef = React.createRef();
    this.state = {
      videoSizeClass: 'small',
    };
  }

  componentDidMount() {
    this.setSizeOfVideoBlocker();
    window.addEventListener('resize', this.setSizeOfVideoBlocker);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setSizeOfVideoBlocker);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isVideoTheatreMinified !== this.props.isVideoTheatreMinified
    ) {
      this.setSizeOfVideoBlocker();
    }
  }

  setSizeOfVideoBlocker = () => {
    if (!(this.blockerRef && this.blockerRef.current)) {
      return;
    }
    let cssClass;
    const iframeWidth = this.blockerRef.current.offsetWidth;
    if (iframeWidth > 600) {
      cssClass = 'large';
    } else if (iframeWidth < 380) {
      cssClass = 'small';
    } else {
      cssClass = 'medium';
    }

    this.setState({
      videoSizeClass: cssClass,
    });
  };

  render() {
    const { prc } = this.props;
    const ctaText = getPrimeBlockerConfig(prc).ctaText || '';
    const headingMsg = getPrimeBlockerConfig(prc).headingMsg || '';
    const videoImg = getVideoImg(this.props.msid, this.props.imgsize);
    const formType = getCtaFormType(prc);
    const blockerBg = {
      backgroundImage: `url(${videoImg})`,
    };
    return (
      <div
        id="primeBlocker"
        className={`${s.prime_vdohooks} ${
          s[this.state.videoSizeClass]
        }  hidden`}
        ref={this.blockerRef}
      >
        <div className={s.prime_imgbg} style={blockerBg} />
        <div className={s.prime_hookinner}>
          {this.props.primeEndDate &&
            headingMsg && (
              <div className={s.freetrial_txt}>
                {` ${headingMsg} ${this.props.primeEndDate}`}
              </div>
            )}
          <div className={s.freetrial_msg}>
            Subscribe to Times Prime for a year and get access to premium videos
            like this from <i className={s.prime_plussvg} /> <br />
            <a
              className={s.learnMore}
              onClick={() => {
                primePaymentflowStartEmitter({
                  formType: 'learnMoreScreen',
                  callback: this.props.hideBlockerAndResume,
                });
              }}
            >
              Learn More
            </a>
          </div>
          <a
            className={s.seetrial_btn}
            data-prime-cta=""
            onClick={() => {
              primePaymentflowStartEmitter({
                formType,
                callback: this.props.hideBlockerAndResume,
              });
            }}
          >
            {ctaText}
          </a>
        </div>
      </div>
    );
  }
}

export default VideoBlocker;
